module.exports = __webpack_public_path__ + "img/ta-hj-leftTitle04.0a8c6b24.png";